// Dedupes logout across tabs so one token-expiry doesn't fan out to N calls
// to Auth0's /v2/logout (one per open tab).

const LOGOUT_LOCK_KEY = "__t1ui_logout_in_progress";
const LOGOUT_LOCK_TTL_MS = 30000;

const state = { activeAt: 0 };

function withinTtl(timestamp) {
  if (!timestamp) return false;
  const elapsed = Date.now() - Number(timestamp);
  return Number.isFinite(elapsed) && elapsed >= 0 && elapsed < LOGOUT_LOCK_TTL_MS;
}

function readLock() {
  try {
    return withinTtl(window.localStorage.getItem(LOGOUT_LOCK_KEY));
  } catch {
    return false;
  }
}

export function isLogoutInProgress() {
  return withinTtl(state.activeAt) || readLock();
}

export function markLogoutInProgress() {
  state.activeAt = Date.now();
  try {
    window.localStorage.setItem(LOGOUT_LOCK_KEY, String(state.activeAt));
  } catch (err) {
    console.error(err);
  }
}

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === LOGOUT_LOCK_KEY && event.newValue) {
      state.activeAt = Date.now();
      window.location.reload();
    }
  });
}
